import { render, staticRenderFns } from "./VTaskCommentItem.vue?vue&type=template&id=9591439c&scoped=true"
import script from "./VTaskCommentItem.vue?vue&type=script&lang=ts"
export * from "./VTaskCommentItem.vue?vue&type=script&lang=ts"
import style0 from "./VTaskCommentItem.vue?vue&type=style&index=0&id=9591439c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9591439c",
  null
  
)

export default component.exports